import type { FC } from "react";
import { InstallOnChrome } from "@/features/installOnChrome";
import type { IComponentBaseProps } from "@/shared/config";
import { useCN } from "@/shared/lib/hooks";
import type { ICall } from "../config";
import curves from "/assets/images/curves.svg";
import "./../style.pcss";

interface ICallProps extends ICall, IComponentBaseProps {}

/**
 * Компонент Call to Action
 * Отображает секцию с призывом к действию
 *
 * @param {ICta & IComponentBaseProps} props - свойства компонента
 * @returns {ReactNode} JSX-разметка блока
 */
export const Call: FC<ICallProps> = ({
  title,
  subtitle,
  baseClass = "call",
  extraClasses = "",
  extraAttrs = {},
}) => {
  const { getCN } = useCN(baseClass);

  return (
    <section
      className={getCN("", {}, [ `relative ${extraClasses ?? ""}` ])}
      {...extraAttrs}
    >
      <div className={getCN("inner")}>
        <div className={"flex flex-col mobile:gap-3"}>
          <h2 className={getCN("title", {}, [ "text-center h2" ])}>{title}</h2>
          <p className={getCN("description", {}, [ "text-center subtitle text-[var(--color-desertStorm)]" ])}>{subtitle}</p>
        </div>
        <div className={getCN("action", {}, [ "mobile:w-full" ])}>
          <InstallOnChrome typeStyle={"base"} />
        </div>
        <img
          src={curves}
          alt={"decorative curves"}
          className={"absolute left-0 top-0 w-full h-auto pointer-events-none rounded-[4rem] mobile:hidden"}
        />
      </div>
    </section>
  );
};
